'use client';

import { CheckCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';

export default function AddOnSuccess() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-4">
      <div className="max-w-md w-full text-center space-y-6 bg-card p-8 rounded-xl shadow-lg">
        <CheckCircle className="h-16 w-16 text-green-500 mx-auto" />
        <h1 className="text-2xl font-bold">Purchase Successful!</h1>
        <p className="text-muted-foreground">
          Your add-on is now active. Launch limit increased.
        </p>
        <Button onClick={() => navigate('/dashboard')} className="w-full">
          Back to Dashboard
        </Button>
      </div>
    </div>
  );
}